/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PricingDto } from './PricingDto';
import {
    PricingDtoFromJSON,
    PricingDtoFromJSONTyped,
    PricingDtoToJSON,
    PricingDtoToJSONTyped,
} from './PricingDto';
import type { BreakdownBeneficiaryDto } from './BreakdownBeneficiaryDto';
import {
    BreakdownBeneficiaryDtoFromJSON,
    BreakdownBeneficiaryDtoFromJSONTyped,
    BreakdownBeneficiaryDtoToJSON,
    BreakdownBeneficiaryDtoToJSONTyped,
} from './BreakdownBeneficiaryDto';

/**
 * Commission entry for a guarantee in a payment breakdown
 * @export
 * @interface BreakdownCommissionDto
 */
export interface BreakdownCommissionDto {
    /**
     * 
     * @type {string}
     * @memberof BreakdownCommissionDto
     */
    remunerationId: string;
    /**
     * 
     * @type {string}
     * @memberof BreakdownCommissionDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof BreakdownCommissionDto
     */
    natureCode: string;
    /**
     * 
     * @type {PricingDto}
     * @memberof BreakdownCommissionDto
     */
    pricing: PricingDto;
    /**
     * 
     * @type {BreakdownBeneficiaryDto}
     * @memberof BreakdownCommissionDto
     */
    beneficiary: BreakdownBeneficiaryDto;
}

/**
 * Check if a given object implements the BreakdownCommissionDto interface.
 */
export function instanceOfBreakdownCommissionDto(value: object): value is BreakdownCommissionDto {
    if (!('remunerationId' in value) || value['remunerationId'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('natureCode' in value) || value['natureCode'] === undefined) return false;
    if (!('pricing' in value) || value['pricing'] === undefined) return false;
    if (!('beneficiary' in value) || value['beneficiary'] === undefined) return false;
    return true;
}

export function BreakdownCommissionDtoFromJSON(json: any): BreakdownCommissionDto {
    return BreakdownCommissionDtoFromJSONTyped(json, false);
}

export function BreakdownCommissionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BreakdownCommissionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'remunerationId': json['remunerationId'],
        'label': json['label'],
        'natureCode': json['natureCode'],
        'pricing': PricingDtoFromJSON(json['pricing']),
        'beneficiary': BreakdownBeneficiaryDtoFromJSON(json['beneficiary']),
    };
}

export function BreakdownCommissionDtoToJSON(json: any): BreakdownCommissionDto {
    return BreakdownCommissionDtoToJSONTyped(json, false);
}

export function BreakdownCommissionDtoToJSONTyped(value?: BreakdownCommissionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'remunerationId': value['remunerationId'],
        'label': value['label'],
        'natureCode': value['natureCode'],
        'pricing': PricingDtoToJSON(value['pricing']),
        'beneficiary': BreakdownBeneficiaryDtoToJSON(value['beneficiary']),
    };
}

